import { getCurrentLanguage } from '@eureka/language-tool';
import { showPackageStatus } from '@patsnap-biz/package-status-dialog';
import type {
    LocaleType,
} from '@patsnap-biz/package-status-dialog';
import '@patsnap-biz/package-status-dialog/lib/style';
import { handleLogout } from '@patsnap-utils/passport';
import psHttp from '@patsnap/common-ps-http';

function openPackageStatusDialog() {
    showPackageStatus({
        baseURL: import.meta.env.VITE_EUREKA_SERVICE_URI,
        passportBaseURL: import.meta.env.VITE_PASSPORT_URI,
        switchTenantClientId: import.meta.env.VITE_PASSPORT_CLIENT_ID,
        switchTenantFrom: 'eureka_ls',
        http: psHttp,
        locale: getCurrentLanguage() as LocaleType,
        expiringThresholdDays: 3,
        // isEnterprise: true,
        onSignInAnotherAccount: () => {
            // 调用登出接口
            handleLogout().then((data: unknown) => {
                const { createLogoutHref } = data as { createLogoutHref: (appendRedirect?: boolean, query?: object) => string }
                const url = createLogoutHref(true, { anonymousLogin: false });
                window.location.href = url;
                window.location.reload();
            });
        },
        onContactAdmin: () => {
            window.open(`${import.meta.env?.VITE_EUREKA_URI}/contact-admin?pkg_type=air_commercial`, '_blank');
        },
    })
}

export {
    openPackageStatusDialog,
};
